const imageCache = new Map();

export async function loadSingleImage(folderName, index) {
  const key = `${folderName}-${index}`;
  if (imageCache.has(key)) return imageCache.get(key);

  try {
    const mod = await import(`../images/${folderName} ${index}.webp`);
    imageCache.set(key, mod.default);
    return mod.default;
  } catch {
    try {
      const mod = await import(`../images/${folderName} ${index}.jpg`);
      imageCache.set(key, mod.default);
      return mod.default;
    } catch {
      try {
        const mod = await import(`../images/${folderName} ${index}.jpeg`);
        imageCache.set(key, mod.default);
        return mod.default;
      } catch {
        try {
          const mod = await import(`../images/${folderName} ${index}.JPG`);
          imageCache.set(key, mod.default);
          return mod.default;
        } catch {
          console.warn(`Could not load: ${folderName} ${index}`);
          return null;
        }
      }
    }
  }
}

export async function loadThumbnail(folderName, thumbnailIndex) {
  return loadSingleImage(folderName, thumbnailIndex);
}

export async function loadProjectGallery(folderName, count) {
  const promises = [];
  for (let i = 1; i <= count; i++) {
    promises.push(loadSingleImage(folderName, i));
  }
  const results = await Promise.all(promises);
  return results.filter(Boolean);
}

export async function loadInitialImages(folderName, count = 5) {
  const promises = [];
  for (let i = 1; i <= Math.min(count, 5); i++) {
    promises.push(loadSingleImage(folderName, i));
  }
  const results = await Promise.all(promises);
  return results.filter(Boolean);
}

export function clearImageCache() { imageCache.clear(); }
export function getCacheSize() { return imageCache.size; }
